import NumberTable, {
  INumberTableProps,
} from "@template/blocks/NumberPickerSection/component/Tables/NumberTable";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";

const Tables: any = () => {
  const numberType = useTypedSelector(
    (state) => state.numbers.options.numberType,
  );

  const isMobile = numberType === "mobile";

  const types: INumberTableProps[] = [
    ...(isMobile
      ? ([
        {
          type: "premium",
          label: "Mobile",
          showAreaCode: true,
        },
      ] as INumberTableProps[])
      : ([
        {
          type: "standard",
          label: "Standard",
          showAreaCode: true,
        },
        {
          type: "premium",
          label: "Memorable",
          showAreaCode: true,
        },
      ] as INumberTableProps[])),
    {
      type: "nonGeo",
      label: "Non-Geographic",
      showAreaCode: false,
    },
  ];

  return (
    <>
      {types.map((type) => (
        <NumberTable
          type={type.type}
          key={type.type}
          label={type.label}
          showAreaCode={type.showAreaCode}
        />
      ))}
    </>
  );
};

export default Tables;
